import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/Container';
import { ButtonLink } from '../../../components';
import { t } from '../../../i18n';
import UrlTo from '../../../url-to';
import BreadCrumbs from '../../components/breadcrumbs';

const GiftCardActivated = () => {
  const breadCrumbItems = [
    {
      url: UrlTo.coursesHome(),
      name: t('DIGITAL_COURSES.HOME_SCREEN.NAME'),
    },
    {
      url: UrlTo.coursesGiftCardRedeem(),
      name: t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.ACTIVATE_GIFT_CARD'),
    },
    {
      isActive: true,
      name: t('DIGITAL_COURSES.GIFT_CARD_REDEEMED.ACTIVATED'),
    },
  ];

  return (
    <Container>
      <BreadCrumbs navigationLinks={breadCrumbItems} />
      <h1>{t('DIGITAL_COURSES.GIFT_CARD_REDEEMED.ACTIVATED')}</h1>
      <Alert variant="info">{t('DIGITAL_COURSES.GIFT_CARD_REDEEMED.INSTRUCTIONS')}</Alert>
      <ButtonLink type="green" text={t('OK')} href={UrlTo.coursesHome()} />
    </Container>
  );
};

export default GiftCardActivated;
